import React from 'react';
import { useInView } from 'react-intersection-observer';
import { ArrowRight, BookOpen } from 'lucide-react';
import { useSectionData } from '../hooks/useSectionData';
import { fetchBlogs, attr, getImageUrl } from '../services/api';

const BLOG_URL = 'https://blog.rupeshbhatta.com.np';

function fmtDate(d) {
  if (!d) return '';
  return new Date(d).toLocaleDateString('en-US', { day: 'numeric', month: 'short', year: 'numeric' });
}

export default function Blog() {
  const items = useSectionData(fetchBlogs);
  const { ref, inView } = useInView({ threshold: 0.08, triggerOnce: true });

  if (!items) return null;

  return (
    <section id="blog" ref={ref} className={`section${inView ? ' visible' : ''}`}>
      <div className="container">
        <header className="section-header">
          <p className="section-label">blog</p>
          <h2 className="section-title">Latest Writing</h2>
          <div className="section-line" />
        </header>

        <div className="blog-grid">
          {items.map((item, i) => {
            const a = attr(item);
            const thumb = getImageUrl(a.thumbnail);
            const postUrl = a.slug ? `${BLOG_URL}/${a.slug}` : BLOG_URL;

            return (
              <a
                key={i}
                href={postUrl}
                target="_blank"
                rel="noreferrer noopener"
                className="blog-card"
                style={{ textDecoration: 'none' }}
              >
                {thumb ? (
                  <img src={thumb} alt={a.title} className="blog-thumb" loading="lazy" />
                ) : (
                  <div className="blog-thumb-placeholder" aria-hidden="true">
                    <BookOpen size={28} />
                  </div>
                )}

                <div className="blog-body">
                  {a.publishedAt && (
                    <p className="blog-date">{fmtDate(a.publishedAt)}</p>
                  )}
                  <h3 className="blog-title">{a.title}</h3>
                  {a.subtitle && (
                    <p className="blog-subtitle">{a.subtitle}</p>
                  )}
                  <span className="blog-read">
                    Read more <ArrowRight size={13} />
                  </span>
                </div>
              </a>
            );
          })}
        </div>

        <div className="blog-footer-link">
          <a
            href={BLOG_URL}
            target="_blank"
            rel="noreferrer noopener"
            className="btn-outline"
          >
            All Posts <ArrowRight size={15} />
          </a>
        </div>
      </div>
    </section>
  );
}
